import { createGroup } from "firebase-config";
import { buildPickemGroupPath } from "pages/PageConfigs";
import { useState } from "react";
import { useNavigate } from "react-router";
import { CenterFlexRow } from "styles/layout";
import { ErrorText } from "styles/text";
import {
  JoinTypeClosed,
  JoinTypeOpen,
  JoinTypeRequest,
  MAX_GROUP_NAME_LENGTH,
  MIN_GROUP_NAME_LENGTH,
} from "TrackmaniaDetails";
import {
  FormContainer,
  FormTable,
  InProgressSpinner,
  Input,
  CreateGroupButton,
  CreateGroupSelect,
} from "./styles";

const VALID_GROUP_NAME_CHARS = /^[a-zA-Z0-9_\\. -']+$/;

export const PickemCreateGroupForm = () => {
  const navigate = useNavigate();
  const [groupName, setGroupName] = useState<string>("");
  const [selectedJoinType, setSelectedJoinType] =
    useState<string>(JoinTypeOpen);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [controlsDisabled, setControlsDisabled] = useState<boolean>(false);

  const canCreateGroup = () => {
    return (
      groupName.length >= MIN_GROUP_NAME_LENGTH &&
      groupName.length <= MAX_GROUP_NAME_LENGTH &&
      VALID_GROUP_NAME_CHARS.test(groupName)
    );
  };

  const onClickCreateGroup = async () => {
    setControlsDisabled(true);
    setErrorMessage("");
    await new Promise((r) => setTimeout(r, 2000));
    createGroup({ groupName: groupName, joinType: selectedJoinType })
      .then((result) => {
        const data: any = result.data;
        navigate(buildPickemGroupPath(data.groupId));
      })
      .catch((error) => {
        setErrorMessage(error.message);
      })
      .finally(() => {
        setControlsDisabled(false);
      });
  };

  return (
    <FormContainer>
      <FormTable>
        <tbody>
          <tr>
            <th>Group Name</th>
            <td>
              <Input
                type="text"
                maxLength={MAX_GROUP_NAME_LENGTH}
                value={groupName}
                onChange={(e) => {
                  setGroupName(e.target.value);
                }}
              />
            </td>
          </tr>
          <tr>
            <th>Join Type</th>
            <td>
              <CreateGroupSelect
                value={selectedJoinType}
                onChange={(e) => {
                  setSelectedJoinType(e.target.value);
                }}
              >
                <option value={JoinTypeOpen}>{JoinTypeOpen}</option>
                <option value={JoinTypeRequest}>{JoinTypeRequest}</option>
                <option value={JoinTypeClosed}>{JoinTypeClosed}</option>
              </CreateGroupSelect>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <CenterFlexRow>
                <CreateGroupButton
                  onClick={onClickCreateGroup}
                  disabled={!canCreateGroup() || controlsDisabled}
                >
                  {controlsDisabled ? <InProgressSpinner /> : "Create Group"}
                </CreateGroupButton>
              </CenterFlexRow>
            </td>
          </tr>
        </tbody>
      </FormTable>
      <ErrorText>{errorMessage}</ErrorText>
    </FormContainer>
  );
};
